// extracted by mini-css-extract-plugin
export default {"mainContainer":"AppliedJobs_mainContainer__4I0fc","sideContainer":"AppliedJobs_sideContainer__4vJVS","statusCount":"AppliedJobs_statusCount__dfbpn"};